export interface ModelSlotErrorMessages {
  invalidUrl: string;
  unsupportedFormat: string;
  fileTooLarge: string;
}

/** Convert server-only model slot validation codes into user-facing copy. */
export function formatModelSlotGenerationError(
  error: string,
  messages: ModelSlotErrorMessages
): string {
  if (error.startsWith('MODEL_SLOT_INVALID_URL:')) return messages.invalidUrl;
  if (error.startsWith('MODEL_SLOT_UNSUPPORTED_FORMAT:')) return messages.unsupportedFormat;
  if (error.startsWith('MODEL_SLOT_FILE_TOO_LARGE:')) return messages.fileTooLarge;
  return error;
}
